import { useEffect } from "react";

export default function useClickOutside(ref, fun) {
  useEffect(() => {
    const listener = (e) => {
      // Ignorar se o clique foi em um input de arquivo ou se não há target
      if (!e.target || e.target.type === "file") {
        return;
      }

      // Ignorar se o elemento não existe ou se o clique foi dentro do elemento
      if (!ref.current || ref.current.contains(e.target)) {
        return;
      }

      // Ignorar cliques em elementos do emoji picker ou outros popups
      const emojiPicker = document.querySelector(".EmojiPickerReact");
      if (emojiPicker && emojiPicker.contains(e.target)) {
        return;
      }

      fun();
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}
